import React from "react";
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

/* The grey panel beside each service. The original site hid these topics in an arrow-only slider,
*  so the topic titles are now shown as tabs to make it clear what's in there.
*/
const TopicTabs = ({ id, topics }) => {
  const [index, setIndex] = React.useState(0);
  const topic = topics[index];

  const go = (step) => setIndex((index + step + topics.length) % topics.length);

  //Arrow keys move between tabs (standard tablist keyboard behaviour)
  const onKeyDown = (e) => {
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      go(1);
    }
    else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      go(-1);
    }
  };

  return (
    <div className={"topic-panel"}>
      <span
        className={"topic-bubbles"}
        aria-hidden={"true"}
      />
      <div
        className={"topic-tabs"}
        role={"tablist"}
        aria-label={"Topics"}
        onKeyDown={onKeyDown}
      >
        {topics.map((t, i) => (
          <button
            key={t.title}
            id={`${id}-tab-${i}`}
            type={"button"}
            role={"tab"}
            aria-selected={i === index}
            aria-controls={`${id}-panel`}
            tabIndex={(i === index) ? 0 : -1}
            className={(i === index) ? "active" : ""}
            onClick={() => setIndex(i)}
          >
            {t.title}
          </button>
        ))}
      </div>

      <div
        key={index}
        id={`${id}-panel`}
        role={"tabpanel"}
        aria-labelledby={`${id}-tab-${index}`}
        className={"topic-body"}
      >
        <h3>{topic.title}</h3>
        {topic.paragraphs.map((p) => <p key={p}>{p}</p>)}
        {topic.list ? (
          <ul>
            {topic.list.map((item) => <li key={item}>{item}</li>)}
          </ul>
        ) : null}
      </div>

      <div className={"topic-nav"}>
        <span>{`${index + 1} / ${topics.length}`}</span>
        <IconButton
          size={"small"}
          onClick={() => go(-1)}
          aria-label={"Previous topic"}
        >
          <ChevronLeft />
        </IconButton>
        <IconButton
          size={"small"}
          onClick={() => go(1)}
          aria-label={"Next topic"}
        >
          <ChevronRight />
        </IconButton>
      </div>
    </div>
  );
};

export default TopicTabs;
